import {ActionCreatorDefinition, createAction} from "redux-ts";
import {Deal} from "platform/protocol/trading/Deal";

export const SetClosedTradesType: string =  "SetClosedTrades";
export const SetClosedTradesPendingType: string =  "SetClosedTradesPending";

export interface SetClosedTradesPayload {

    ClosedTrades: Deal[];
}

export interface SetClosedTradesPendingPayload {

    pending: boolean;
}

export const SetClosedTrades: ActionCreatorDefinition<SetClosedTradesPayload, any> = createAction<SetClosedTradesPayload>(SetClosedTradesType);
export const SetClosedTradesPending: ActionCreatorDefinition<SetClosedTradesPendingPayload, any> = createAction<SetClosedTradesPendingPayload>(SetClosedTradesPendingType);
